exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .cdk-overlay-pane .mat-autocomplete-panel{min-width:130px}.mat-form-field-invalid{color:red}", ""]);

// exports
